import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone.js';
import utc from 'dayjs/plugin/utc.js';

import { safeCall } from '@xemplo/safe-call';

import { DEFAULT_DATE_FORMAT } from './date-time.const';
import { FormatDateProps } from './date-time.types';

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * @deprecated Use DateTimeHelper from @xemplo/date-time instead
 */
export const formatDate = ({
  value,
  format = DEFAULT_DATE_FORMAT,
  isUtc = false,
  fallback = 'N/A',
}: FormatDateProps) => {
  if (!value) return fallback;

  const [baseDate, error] = safeCall(() => {
    return isUtc ? dayjs.utc(value).tz(getBrowserTimezone()) : dayjs(value);
  });

  if (error || !baseDate?.isValid()) {
    return typeof value === 'string' ? value : fallback;
  }

  return baseDate.format(format);
};

export function getBrowserTimezone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

export const isPastDate = (date?: string | Date) => {
  if (!date) return false;
  return dayjs().isAfter(dayjs(date));
};

export function formatMinutes(minutes: number) {
  if (!minutes) return null;
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = Math.floor(minutes % 60);
  return `${hours}h ${remainingMinutes < 10 ? '0' : ''}${remainingMinutes}m`;
}
